import React from 'react';
import './TopBar.css';
import { Link } from 'react-router-dom';

const TopBar = () => {
    return (
        <div className="topbar">
            <div className="topbar-left">
           <Link to="/">  <img src="https://res.cloudinary.com/dd8cg94ku/image/upload/v1736775982/Untitled_design_9_qj2els.webp" alt="Apex Logo" className="topbar-logo" /></Link>   
                <div className="topbar-heading">
                    <h1 className="topbar-title">The Golden Palace</h1>
                    <p className="topbar-subtitle">
                        A Luxuries Marriage Garden & Resort
                    </p>
                </div>
            </div>
            <div className="topbar-right">
                <p className="topbar-contact">
                    📞 +91-9001710160
                </p>
                <p className="topbar-email">
                    ✉️ thegoldenpalacedidwana@gmail.com
                </p>
            </div>
        </div>
    );
};

export default TopBar;
